import _ from 'lodash';
import React from 'react';

import Kbd from 'design-system/Kbd';
import { validateAttribute } from '@scale/shared/annotation';
import { convertNumberInput } from './utils';

interface AttributeNumberInputProps {
  isReadOnly?: boolean;
  className?: string;
  attrParams: $FIXME;
  selectedChoice?: string;
  attrKey: string;
  handleUpdateSelection: (attrKey: string, attrVal: string | number | undefined) => void;
  shortcutDisplay?: boolean;
}

export default class AttributeNumberInput extends React.Component<AttributeNumberInputProps> {
  handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (_.includes(['Enter', 'Escape'], e.key)) {
      if (!(e.key === 'Enter' && this.props.shortcutDisplay)) {
        // *hides in shame*
        document.body.tabIndex = 1;
        document.body.focus();
      }

      e.stopPropagation();
    }

    if (e.key === '[') {
      e.preventDefault();
    }
  };

  render() {
    const className = validateAttribute(this.props.selectedChoice, this.props.attrParams, null)
      ? 'valid'
      : 'invalid';

    return (
      <div className="number-input">
        <input
          type="number"
          className={className}
          max={this.props.attrParams.max}
          min={this.props.attrParams.min}
          step={this.props.attrParams.step || 1}
          onChange={e =>
            !this.props.isReadOnly &&
            this.props.handleUpdateSelection(this.props.attrKey, convertNumberInput(e.target.value))
          }
          onKeyDown={this.handleKeyDown}
          value={this.props.selectedChoice}
        />

        {!this.props.shortcutDisplay && (
          <div>
            <Kbd>Enter</Kbd> <strong>to confirm</strong>
          </div>
        )}

        <style jsx>{`
          .number-input {
            margin-bottom: 12px;
            display: flex;
            align-items: center;
          }

          .number-input input {
            margin: 8px 12px 8px 0px;
            height: 36px;
            outline: 0;
            box-shadow: none;
            border-radius: 4px;
            border: 1px solid #ccc;
            padding: 2px 8px;
            font-weight: bold;
            width: 70px;
          }

          .number-input input + div {
            opacity: 0;
            transition: 0.2s;
          }

          .number-input input:focus {
            box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
            border: 1px solid var(--color-primary);
          }

          .number-input input:focus + div {
            opacity: 1;
          }

          .number-input input.valid {
            color: var(--color-primary);
          }
        `}</style>
      </div>
    );
  }
}
